module.exports = __webpack_public_path__ + "media/components/weather-icon/static/dayheavyrain-472729e1b1a0aae5abab6d24f2f99055.png";